import { EDIT_PROFILE_SUCCESS, EDIT_PROFILE_FAILURE, PROFILE_DETAILS_SUCCESS, PROFILE_DETAILS_FAILURE, PROFILE_COMPLETION_SUCCESS} from "./profile.actionTypes";

const initialState = {
    user_details: null,
    completion: null
  };
  
  export default function profileReducer(state = initialState, { type, payload }) {
    switch (type) {
      // case EDIT_PROFILE_SUCCESS:
      //   return {
      //     ...state,
      //     resource: payload,
      //   };
      // case EDIT_PROFILE_FAILURE:
      //   return {
      //     ...state,
      //     message: "",
      //   };

      case PROFILE_DETAILS_SUCCESS:
        return {
          ...state,
          user_details: payload,
        };
      case PROFILE_DETAILS_FAILURE:
        return {
          ...state,
          message: "",
        };

            case PROFILE_COMPLETION_SUCCESS:
        return {
          ...state,
          completion: payload,
        };
      case PROFILE_COMPLETION_SUCCESS:
        return {
          ...state,
          message: "",
        };
  
      default:
        return state;
    }
  }